// utils.js — shared constants, API helper, session helpers

export const API        = "https://cip.medsphere.net/api";
export const STATIC_AUTH = "12345";
export const CACHE_KEY  = "pv_session";
export const THUMB_BASE  = "https://cip.medsphere.net/kmpthumbs/";
export const ATTACH_BASE = "https://cip.medsphere.net/kmpattach/";
export const LOGO_BASE  = "https://cip.medsphere.net/kmpattach/company_logo/";

// ─── Colors ───────────────────────────────────
export const C = {
  primary: "#185FA5", dark: "#0C447C", darker: "#042C53",
  light: "#E6F1FB", mid: "#378ADD", border: "#B5D4F4",
  white: "#fff", bg: "#F4F7FB", surface: "#fff",
  text: "#042C53", muted: "#5a7a9a", hint: "#8aabca",
  success: "#1D9E75", successBg: "#E1F5EE",
  error: "#A32D2D", errorBg: "#FCEBEB",
  sidebar: "#042C53", sidebarHover: "#0C447C",
};

// ─── API helper ───────────────────────────────
export const post = async (ep, body, authCode = STATIC_AUTH) => {
  const fd = new FormData();
  Object.entries(body).forEach(([k, v]) => fd.append(k, v));
  const r = await fetch(`${API}/${ep}`, {
    method: "POST",
    headers: { "Auth-Code": authCode },
    body: fd
  });
  return r.json();
};

// ─── Session helpers ──────────────────────────
export const saveSession  = (d) => { sessionStorage.setItem(CACHE_KEY, JSON.stringify(d)); localStorage.setItem(CACHE_KEY, JSON.stringify(d)); };
export const loadSession  = () => { try { return JSON.parse(sessionStorage.getItem(CACHE_KEY)) || JSON.parse(localStorage.getItem(CACHE_KEY)); } catch { return null; } };
export const clearSession = () => { sessionStorage.removeItem(CACHE_KEY); localStorage.removeItem(CACHE_KEY); };